module.exports = __webpack_public_path__ + "assets/img/ins_b.09e6ba43.svg";